export default __webpack_public_path__ + "static/media/bank-transfer.03fcef68.svg";